var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMagnifier = function SvgMagnifier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0932 11.522H12.2657L11.9724 11.2392C12.9989 10.0451 13.6169 8.49487 13.6169 6.80846C13.6169 3.0481 10.5688 0 6.80846 0C3.0481 0 0 3.0481 0 6.80846C0 10.5688 3.0481 13.6169 6.80846 13.6169C8.49487 13.6169 10.0451 12.9989 11.2392 11.9724L11.522 12.2657V13.0932L16.7593 18.32L18.32 16.7593L13.0932 11.522ZM6.80846 11.522C4.2003 11.522 2.09491 9.41663 2.09491 6.80846C2.09491 4.2003 4.2003 2.09491 6.80846 2.09491C9.41663 2.09491 11.522 4.2003 11.522 6.80846C11.522 9.41663 9.41663 11.522 6.80846 11.522Z",
    fill: "#494E55"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagnifier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magnifier.4ad55827.svg";
export { ForwardRef as ReactComponent };